import _app from '../main'
import { compareVersion, getVersion } from './index'
function setupWebViewJavascriptBridge(callback) {
  if (navigator.userAgent.indexOf('UNI_VERSION') > -1) {
    try {
      window.uniBridge = {
        callHandler: (action, data, cb) => {
          const _d = {
            data: {
              action,
              data,
            }
          };
          window.uni.postMessage(_d);
          if (window.UNICB) { return window.UNICB.push(cb); }
          window.UNICB = [cb];
        }
      }
      callback(window.uniBridge);
    } catch(e) {
      alert(JSON.stringify(e))
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady'
        , function() {
          callback(window.WebViewJavascriptBridge)
        },
        false
      );
    }
  
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
  }
}

// 调取登录
export function goLogin() {
  try {
    setupWebViewJavascriptBridge(function(bridge) {
      bridge.callHandler('login', null, function(resp) {
        console.log(resp);
      })
    })
  } catch (err) {
    _app.$toast.show('登录失败，请稍后再试！')
  }
}

export function jumpToApp (data) {
  const versionMsg = getVersion()
  const isIOS = (versionMsg.os === 'IOS');
  if (isIOS && compareVersion(versionMsg.version, '1.2.13') === 1 && !data.isEncode) { // iOS 版本 > 1.2.13  link decodeURI
    data.url = decodeURIComponent(data.url);
  }
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('jumpToApp', data, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * 分享
 * @param data
 * title: 分享标题
 * desc: 描述文案
 * thumbImageUrl：分享的icon
 * pageUrl: 页面地址
 * imgUrls：图片列表
 */
export function setShare (data, callBack) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('setShare', data, function(resp){
        console.log(resp);
      });
    });
  } catch (e) {
    _app.$toast.show('分享失败，请稍后再试！')
  } finally {
    callBack && callBack();
  }
}

/**
 * 设置Toast
 * @param data
 * text: 文案
 */
export function setToast(data) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('setToast', data, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * 复制文本
 * @param data
 * text: 复制文本
 */
export function copyAction (data) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('copyAction', data, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * 页面跳转
 * @param data
 * pageUrl: 页面路径
 *
 * 详情页  proDetail?id=72345825&es=true
 * 搜索页  search?keyWord=衣服
 * 个人中心  ucenter
 * 升级    update
 */
export function jumpInto (data) {
  console.log(data)
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('jumpInto', data, function(resp){
        console.log(resp);
      });
    });
  } catch (e) {
    _app.$toast.show('页面跳转失败，请稍后再试！')
  }
}

/**
 * 商品分享弹窗
 * @param data
 * imgUrls: 图片urls
 * text: 文案
 * sourcePlatType：商品平台
 */
export function shareAlertAction (data) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('shareAlertAction', data, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * 设置标题
 * @param data
 * left: {type: 'BACK', jsFn: 'console.log'},
 * middle: {type: 'TITLE', text: '设置标题头'}
 */
export function setTitle (data) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('setTitle', data, function(resp){
        console.log(resp);
      });
    });
  } catch (e) {
    console.log(e);
  }
}

// 用户授权
export function goAuthorization(callBack) {
  try {
    setupWebViewJavascriptBridge(function(bridge) {
      bridge.callHandler('auth', null, function(resp) {
        if (resp === 'true') {
          _app.$toast.show('授权成功')
          callBack();
        } else {
          _app.$toast.show('授权失败，请稍后再试！')
        }
      })
    })
  } catch(err) {
    _app.$toast.show('授权失败，请稍后再试！')
  }
}

// 返回上一页
export function goBack() {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('goBack', {}, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * chooseImage
 * @param data
 * count: 图片数量
 */
export function chooseImage(data, callBack) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('chooseImage', data, function(resp){
        callBack(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}

/**
 * 跳转到appstore
 * @param data
 * url: itunes地址
 */
export function appstore(data) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('appstore', data, function(resp){
        console.log(resp);
      });
    });
  } catch (err) {
    console.log(err);
  }
}


// 跳转小程序
export function navigateToMiniProgram(data, extData = {}, callBack = () => {}) {
  try {
    setupWebViewJavascriptBridge(function(bridge) {
      bridge.callHandler('navigateToMiniProgram', data, extData, callBack)
    })
  } catch(err) {
    _app.$toast.show('跳转小程序失败！')
  }
}